// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__6YD8u","head":"Table_head__2lOKN","col":"Table_col__3xuYd"};